// extracted by mini-css-extract-plugin
export default {"container":"tB-z","dimension":"uB-z","dimensionLabels":"vB-z"};